/**
 * @Create idler.zhu(zqc.sunny@aliyun.com)
 * @CreateDate  2017/12/6
 */
import './app.css';
import React from 'react';
import {Provider} from 'react-redux'
import Routes from '../routes';
import store from '../store';

const App = () =>
  <Provider store={store}>
    <Routes />
  </Provider>;

export default App;



// WEBPACK FOOTER //
// ./src/components/app.js